// extracted by mini-css-extract-plugin
export default {"container":"CheckboxInput_container__sf8YF","label":"CheckboxInput_label__dpCZ0","text":"CheckboxInput_text__UTcjz","input":"CheckboxInput_input__9x2Qi"};